module.exports = {
	1: 'บก.ทอ.',
	19: 'สลก.ทอ.',
	29: 'สบ.ทอ.',
	49: 'กพ.ทอ.',
	90: 'ขว.ทอ.',
	165: 'ยก.ทอ.',
	202: 'กบ.ทอ.',
	258: 'กร.ทอ.',
	283: 'ทสส.ทอ.',
	312: 'สปช.ทอ.',
	339: 'กง.ทอ.',
	370: 'จร.ทอ.',
	390: 'สตน.ทอ.',
	430: 'สนภ.ทอ.',
	453: 'สธน.ทอ.',
	220012: 'ศซบ.ทอ.',
	220704: 'สบน.ทอ.',
	471: 'บน.1',
	814: 'บน.2',
	220756: 'บน.3',
	1135: 'บน.4',
	1504: 'บน.6',
	1829: 'บน.7',
	2125: 'บน.21',
	2378: 'บน.23',
	2634: 'บน.41',
	2889: 'บน.46',
	3142: 'บน.5',
	3397: 'บน.56',
	3652: 'รร.การบิน',
	221286: 'คปอ.',
	4040: 'อย.',
	220026: 'ศปอว.ทอ.',
	4586: 'ชอ.',
	5245: 'สอ.ทอ.',
	5422: 'สพ.ทอ.',
	5612: 'พอ.',
	5773: 'พธ.ทอ.',
	5908: 'ชย.ทอ.',
	6136: 'ขส.ทอ.',
	220467: 'ศซว.ทอ.',
	6346: 'ยศ.ทอ.',
	219501: 'รร.นนก.',
	6562: 'สก.ทอ.',
	6610: 'ศวอ.ทอ.',
	6648: 'สวบ.ทอ.',
	6675: 'สน.ผบ.ดม.',
	221827: 'ศฝ.ทอ.น้ำพอง'
}
